import { defineComponent as _defineComponent } from 'vue'
import MainLayout from '@/components/layouts/MainLayout.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return { __sfc: true,MainLayout }
}

})